
/* eslint-disable max-len */
import React from 'react';
import { LFC } from '../../../Legacy';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';
import { Button, Prompt } from './../../../ui';
import { ManageAccessView } from './ManageAccessView';

export const manageAccessPopup = () => ({ ui: ManageAccessPopup });

export const ManageAccessPopup: LFC<PopupProps> = ({ action, dismiss, args }) => {
    return <Prompt ignoreEnter onAction={dismiss}>
        <Popup p="0">
            <Flexer padding="1.5 1.5 0">
                <Popup.Title>
                    Manage Access
                </Popup.Title>
            </Flexer>
            <Popup.Content>
                <ManageAccessView />
            </Popup.Content>
            <Flexer padding="0 1.5 1.5">
                <Popup.Actions>
                    <Button onAction={dismiss}>Close</Button>
                </Popup.Actions>
            </Flexer>
        </Popup>
    </Prompt>;
};
